define([
	"dojo/_base/declare",
	"./ProductSwitchboard"
], function(declare, ProductSwitchboard) {

	return declare(ProductSwitchboard, {
		idViewProperty: "bomActiveColors",
		productStoreName: "bomColorStore"
	});
});
